import { SVGProps } from "react";

export const FDUSDIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 141.8 141.7"
    {...props}
  >
    <path
      d="M70.9,141.7C31.7,141.7,0,110,0,70.9S31.7,0,70.9,0s70.9,31.7,70.9,70.9S110,141.7,70.9,141.7z"
      fill="#000000"
    />
    <g transform="translate(96.43495,-0.68691) scale(1.24272,1.24272)">
      <polygon
        fill="#FFFFFF"
        points="9.8,49 9.8,62.4 -27,62.4 -27,27.4 9.8,27.4 9.8,40.8 -11.8,40.8 -11.8,49"
      />
      <rect x="-55.4" y="70.2" fill="#00E98D" width="45.8" height="19.1" />
    </g>
  </svg>
);
